angular.
module("digiexam.components").
directive("growingTextarea", function growingTextareaDirective($timeout) {
	"use strict";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "directives/growing-textarea.html",
		scope: {
			ngModel: "=",
			ngId: "@",
			ngChange: "&",
			ngDisabled: "@",
			ngReadonly: "@",
			ngPlaceholder: "@",
			// Can't use ngClass because then it would also be applied
			// to the directive root element.
			ngClasses: "@",
		},

		link: function link($scope) {
			$scope.parentEval = function parentEval(attribute) { // eslint-disable-line consistent-return
				if (typeof $scope[attribute] !== "undefined") {
					return $scope.$parent.$eval($scope[attribute]);
				}
			};

			// NOTE(robin): This is a hack to fix a lifecycle problem in angular
			// If you call ngChange on the parent directly, either through this
			// or parentEval() ngChange will be called on the parent before the
			// new ngModel value has been applied on the parent.
			//
			// Expected is that ngChange is called after ngModel has been updated
			//
			// That means if you use the ngModel in ngChange you will get the
			// previous state of the model value
			//
			// I tried to look into $commitViewValue and other nicer solutions,
			// but the model value in this scope is applied,
			// it's just not propagated to the parent scope
			$scope.onChange = function onChange() {
				if ($scope.ngChange) {
					$timeout(function onChangeTimeout() {
						$scope.ngChange();
					}, 1);
				}
			};
		},
	};
});
